<template>
  <div class="actual-calculation">
    <div class="actual-calculation__content">
      <component :is="iconComponent" class="actual-calculation__icon" />
      <span v-if="label" class="actual-calculation__label">{{ typeLabel }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import LastIcon from './LastIcon.vue';
import AverageIcon from './AverageIcon.vue';

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => ['Last', 'Average'].includes(value),
  },
  label: {
    type: Boolean,
    default: false,
  },
});

const iconComponent = computed(() => {
  return props.type === 'Last' ? LastIcon : AverageIcon;
});

const typeLabel = computed(() => {
  return props.type;
});
</script>

<style scoped>
.actual-calculation {
  display: inline-flex;
  align-items: center;
}

.actual-calculation__content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.actual-calculation__icon {
  display: inline-block;
  flex-shrink: 0;
}

.actual-calculation__label {
  color: #000000;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  user-select: none;
}
</style>
